import { render } from "./PopoverButton.vue?vue&type=template&id=97151008&ts=true"
import script from "./PopoverButton.vue?vue&type=script&lang=ts"
export * from "./PopoverButton.vue?vue&type=script&lang=ts"

import "./PopoverButton.vue?vue&type=style&index=0&id=97151008&lang=scss"

import exportComponent from "/Users/colin/Documents/FUSE/code/live/fusestudio.net/Graphite/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__